const resources = {
    usName: 'États-Unis',
    caName: 'Canada',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    address2Label: 'Appartement, étage, etc.',
    add: 'Ajouter',
    country: 'Pays',
    streetAddress: 'Adresse',
    city: 'Ville',
    phone: 'Téléphone',
    postalCode: 'Code postal',
    zipPostalCode: 'Code postal',
    emailAddress: 'Courriel',
    enterZipCodeText: 'Saisir un code ZIP/postal pour voir la ville et l’État/la région.',
    region: 'Région',
    stateRegion: 'État/Région',
    province: 'Province',
    emailRequiredText: 'Vous devez fournir votre adresse courriel pour recevoir les notifications d’expédition et suivre votre commande.'
};

module.exports = function getResource(label) {
    return resources[label];
};
